/**
 * @voltxampere/ui — Wire (Kablo)
 *
 * The thinnest of the connectors: a horizontal stroke spanning the
 * full viewBox. Sprint 11 canvas treats wires as edges between
 * arbitrary terminals; this symbol is the palette swatch only.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_HEAVY, VIEWBOX_DEFAULT } from "./constants.js";
export const wire = {
    id: "wire",
    nameTr: "Kablo",
    nameEn: "Wire",
    shortcut: "W",
    category: "connector",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, polarity: "bi" },
        { x: 40, y: 13, polarity: "bi" },
    ],
    renderSVG: () => `<line x1="0" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_HEAVY)}"/>`,
};
//# sourceMappingURL=wire.js.map